import { Link } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';

const stats = [
  { value: '50+', label: 'Años de vida útil del material' },
  { value: '2022', label: 'Transformando desde' },
  { value: '18.000+', label: 'Personas conscientizadas' },
  { value: '320+', label: 'Instituciones vinculadas' },
];

const slides = [
  {
    src: 'https://readdy.ai/api/search-image?query=photorealistic%20park%20in%20Bucaramanga%20Colombia%20with%20benches%20chairs%20and%20pedestrian%20walkways%20made%20from%20recycled%20plastic%20wood%20lumber%20in%20warm%20earth%20tones%2C%20lush%20tropical%20trees%20and%20green%20grass%2C%20families%20walking%2C%20natural%20sunlight%20filtering%20through%20canopy%2C%20ultra%20detailed%20real%20photography%20style%2C%20high%20resolution%2C%20vibrant%20colors%2C%20community%20park%20atmosphere%2C%20fountains%20and%20water%20features%2C%20very%20realistic&width=1920&height=1080&seq=frais-s1-v3&orientation=landscape',
    tag: 'Parques Urbanos',
    tagColor: '#2e7d32',
    message: 'El residuo es un error de diseño.',
    sub: 'Nosotros lo corregimos. Parques, senderos y mobiliario construido con madera plástica FRAIS — durable, sin mantenimiento, eterno.',
    accent: '#a5d6a7',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=photorealistic%20pedestrian%20bridge%20over%20a%20clean%20creek%20quebrada%20in%20Colombia%20built%20with%20recycled%20plastic%20wood%20planks%20and%20beams%20in%20natural%20brown%20tones%2C%20crystal%20clear%20water%20flowing%20below%2C%20green%20tropical%20vegetation%20on%20the%20banks%2C%20stone%20and%20dirt%20trail%20leading%20to%20the%20bridge%2C%20realistic%20nature%20photography%2C%20golden%20afternoon%20light%2C%20ultra%20detailed&width=1920&height=1080&seq=frais-s2-v3&orientation=landscape',
    tag: 'Puentes y Quebradas',
    tagColor: '#1565c0',
    message: 'Construimos sobre el agua. No en su contra.',
    sub: 'Puentes peatonales y protección de quebradas con madera plástica FRAIS — inmune a la humedad, sin corrosión, 50 años de vida.',
    accent: '#90caf9',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=photorealistic%20community%20center%20building%20house%20with%20exterior%20cladding%20walls%20and%20decking%20made%20entirely%20from%20recycled%20plastic%20wood%20planks%20in%20warm%20brown%20tones%2C%20modern%20sustainable%20architecture%20in%20Colombian%20tropical%20landscape%2C%20green%20garden%20surroundings%2C%20real%20photo%20quality%2C%20daytime%20sunny%20light%2C%20ultra%20high%20detail&width=1920&height=1080&seq=frais-s3-v3&orientation=landscape',
    tag: 'Fachadas y Casas',
    tagColor: '#e65100',
    message: 'Fachadas que duran generaciones.',
    sub: 'Revestimientos, cerramientos y cubiertas en madera plástica FRAIS — sin pintura, sin termitas, sin óxido. Construir con FRAIS es construir para siempre.',
    accent: '#ffcc80',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=photorealistic%20urban%20sidewalk%20and%20pedestrian%20path%20in%20Colombian%20city%20with%20borders%20and%20curbs%20made%20from%20recycled%20plastic%20wood%20boards%20in%20dark%20brown%20color%2C%20tropical%20street%20trees%2C%20clean%20urban%20environment%2C%20realistic%20street%20photography%2C%20daytime%20warm%20light%2C%20clean%20modern%20city%20sidewalk%2C%20ultra%20detailed%20high%20resolution&width=1920&height=1080&seq=frais-s4-v3&orientation=landscape',
    tag: 'Andenes y Senderos',
    tagColor: '#4e342e',
    message: 'Caminos que no se deterioran.',
    sub: 'Andenes, senderos peatonales y bordillos en madera plástica reciclada — sin grietas, sin huecos, sin mantenimiento correctivo.',
    accent: '#ffccbc',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=photorealistic%20outdoor%20water%20drinking%20fountain%20hydration%20station%20in%20a%20Colombian%20public%20park%20made%20from%20recycled%20plastic%20wood%20and%20metal%2C%20surrounded%20by%20tropical%20plants%20and%20green%20grass%2C%20people%20using%20it%2C%20realistic%20photo%2C%20warm%20sunlight%2C%20ultra%20detailed%20high%20quality%2C%20clean%20public%20infrastructure&width=1920&height=1080&seq=frais-s5-v3&orientation=landscape',
    tag: 'Fuentes de Hidratación',
    tagColor: '#00838f',
    message: 'Infraestructura que cuida la vida.',
    sub: 'Fuentes de hidratación pública construidas con materiales transformados — diseño sostenible al servicio de la comunidad.',
    accent: '#b2ebf2',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=photorealistic%20creek%20conservation%20quebrada%20restoration%20in%20Santander%20Colombia%20with%20plastic%20wood%20retaining%20walls%20and%20protective%20barriers%20along%20the%20banks%2C%20clean%20flowing%20water%2C%20native%20tropical%20vegetation%2C%20workers%20maintaining%20the%20green%20area%2C%20realistic%20landscape%20photography%2C%20bright%20day%2C%20ultra%20detailed&width=1920&height=1080&seq=frais-s6-v3&orientation=landscape',
    tag: 'Conservación de Quebradas',
    tagColor: '#1b5e20',
    message: 'Las quebradas merecen vivir.',
    sub: 'Mantenimiento, conservación y restauración de quebradas con infraestructura de madera plástica FRAIS — resistente al agua y al tiempo.',
    accent: '#c8e6c9',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=photorealistic%20urban%20park%20maintenance%20team%20cleaning%20green%20areas%20in%20Bucaramanga%20Colombia%2C%20workers%20sweeping%20paths%20and%20trimming%20gardens%20around%20park%20furniture%20benches%20and%20pergolas%20made%20of%20recycled%20plastic%20wood%2C%20tropical%20trees%2C%20bright%20sunny%20day%2C%20realistic%20photography%2C%20vibrant%20colors%2C%20community%20workers%20in%20green%20uniforms%2C%20high%20resolution&width=1920&height=1080&seq=frais-s7-v3&orientation=landscape',
    tag: 'Mantenimiento Urbano',
    tagColor: '#558b2f',
    message: 'La ciudad que cuida sus espacios.',
    sub: 'Barrido, limpieza y mantenimiento de jardines, parques y zonas verdes — el ciclo completo del cuidado urbano, con FRAIS.',
    accent: '#dcedc8',
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const [prevSlide, setPrevSlide] = useState<number | null>(null);
  const [transitioning, setTransitioning] = useState(false);
  const [textVisible, setTextVisible] = useState(true);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const goTo = (idx: number) => {
    if (transitioning || idx === current) return;
    setTextVisible(false);
    setTransitioning(true);
    setPrevSlide(current);
    setTimeout(() => {
      setCurrent(idx);
      setTransitioning(false);
      setPrevSlide(null);
      setTimeout(() => setTextVisible(true), 80);
    }, 700);
  };

  useEffect(() => {
    setTextVisible(true);
    intervalRef.current = setInterval(() => {
      setTextVisible(false);
      setTransitioning(true);
      setTimeout(() => {
        setCurrent((prev) => {
          const next = (prev + 1) % slides.length;
          setPrevSlide(prev);
          return next;
        });
        setTransitioning(false);
        setPrevSlide(null);
        setTimeout(() => setTextVisible(true), 80);
      }, 700);
    }, 5500);
    return () => { if (intervalRef.current) clearInterval(intervalRef.current); };
  }, []);

  const resetInterval = (idx: number) => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    goTo(idx);
    intervalRef.current = setInterval(() => {
      setTextVisible(false);
      setTransitioning(true);
      setTimeout(() => {
        setCurrent((prev) => {
          const next = (prev + 1) % slides.length;
          setPrevSlide(prev);
          return next;
        });
        setTransitioning(false);
        setPrevSlide(null);
        setTimeout(() => setTextVisible(true), 80);
      }, 700);
    }, 5500);
  };

  const slide = slides[current];

  return (
    <section className="w-full overflow-hidden">
      <div className="relative w-full" style={{ minHeight: '82vh' }}>

        {prevSlide !== null && (
          <img
            key={`prev-${prevSlide}`}
            src={slides[prevSlide].src}
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-center"
            style={{ opacity: transitioning ? 0 : 1, transition: 'opacity 0.7s ease', zIndex: 1 }}
          />
        )}

        <img
          key={`slide-${current}`}
          src={slide.src}
          alt={slide.message}
          className="absolute inset-0 w-full h-full object-cover object-center"
          style={{ opacity: 1, zIndex: 2, animation: 'heroZoom 7s ease-out forwards' }}
        />

        {/* Warm dark overlay */}
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(to bottom, rgba(10,20,10,0.62) 0%, rgba(15,25,10,0.38) 45%, rgba(10,15,5,0.78) 100%)',
            zIndex: 3,
          }}
        ></div>

        <div
          className="relative flex flex-col justify-between px-6 md:px-16 w-full"
          style={{ zIndex: 4, paddingTop: '88px', paddingBottom: '0', minHeight: '82vh' }}
        >
          {/* Main content */}
          <div className="flex-1 flex flex-col justify-center max-w-5xl mx-auto w-full text-center pt-4 pb-4">

            {/* LOGO — grande */}
            <div
              className="flex items-center justify-center mb-5"
              style={{
                opacity: textVisible ? 1 : 0,
                transform: textVisible ? 'none' : 'translateY(-12px)',
                transition: 'opacity 0.6s ease 0.02s, transform 0.6s ease 0.02s',
              }}
            >
              <img
                src="https://static.readdy.ai/image/04072f05a7ab05cce1b5fc08d2859ba4/b0395c77c26132b4275f62d8aa13c8ff.png"
                alt="Fundación FRAIS"
                className="object-contain"
                style={{
                  height: '90px',
                  width: 'auto',
                  filter: 'drop-shadow(0 4px 16px rgba(0,0,0,0.5)) drop-shadow(0 0 30px rgba(165,214,167,0.2))',
                }}
              />
            </div>

            {/* Nombre completo — sin iconos, texto puro */}
            <div
              style={{
                opacity: textVisible ? 1 : 0,
                transform: textVisible ? 'none' : 'translateY(-8px)',
                transition: 'opacity 0.6s ease 0.08s, transform 0.6s ease 0.08s',
              }}
            >
              <p
                className="text-white font-bold tracking-[0.18em] uppercase mb-1"
                style={{
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: 'clamp(0.62rem, 1.1vw, 0.85rem)',
                  textShadow: '0 2px 8px rgba(0,0,0,0.7)',
                  letterSpacing: '0.2em',
                }}
              >
                Fundación de Reciclaje en Acción Inmediata de Santander
              </p>
            </div>

            {/* NIT — muy resaltado, colores cálidos */}
            <div
              className="flex items-center justify-center gap-3 mb-5"
              style={{
                opacity: textVisible ? 1 : 0,
                transition: 'opacity 0.6s ease 0.14s',
              }}
            >
              <div
                className="inline-flex items-center gap-2.5 px-5 py-2 rounded-full"
                style={{
                  background: 'linear-gradient(135deg, #ff6f00 0%, #e65100 100%)',
                  boxShadow: '0 4px 18px rgba(230,81,0,0.55)',
                }}
              >
                <span
                  className="text-white font-black tracking-[0.22em] uppercase"
                  style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '0.8rem' }}
                >
                  NIT: 901846693-3
                </span>
              </div>
              <div
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full"
                style={{
                  background: 'rgba(255,255,255,0.1)',
                  backdropFilter: 'blur(8px)',
                  border: '1px solid rgba(255,255,255,0.22)',
                }}
              >
                <span
                  className="text-white/80 text-[10px] tracking-[0.2em] uppercase font-semibold"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  87 municipios · Santander · Desde 2022
                </span>
              </div>
            </div>

            {/* Slide tag */}
            <div
              style={{
                opacity: textVisible ? 1 : 0,
                transform: textVisible ? 'none' : 'translateY(-10px)',
                transition: 'opacity 0.6s ease 0.1s, transform 0.6s ease 0.1s',
              }}
            >
              <span
                className="inline-flex items-center text-white text-[10px] font-bold tracking-[0.4em] uppercase px-5 py-2 rounded-full mb-5"
                style={{ backgroundColor: slide.tagColor + 'dd', fontFamily: "'Montserrat', sans-serif" }}
              >
                {slide.tag}
              </span>
            </div>

            {/* Main headline */}
            <h1
              className="font-bold text-white leading-tight mb-4"
              style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: 'clamp(2rem, 4.2vw, 4.5rem)',
                textShadow: '0 3px 20px rgba(0,0,0,0.6)',
                opacity: textVisible ? 1 : 0,
                transform: textVisible ? 'none' : 'translateY(24px)',
                transition: 'opacity 0.7s cubic-bezier(0.16,1,0.3,1) 0.18s, transform 0.7s cubic-bezier(0.16,1,0.3,1) 0.18s',
              }}
            >
              {slide.message}
            </h1>

            {/* Sub text */}
            <p
              className="text-white/85 text-sm md:text-base leading-relaxed max-w-2xl mx-auto mb-7"
              style={{
                fontFamily: "'Montserrat', sans-serif",
                textShadow: '0 1px 8px rgba(0,0,0,0.5)',
                opacity: textVisible ? 1 : 0,
                transform: textVisible ? 'none' : 'translateY(16px)',
                transition: 'opacity 0.7s ease 0.32s, transform 0.7s ease 0.32s',
              }}
            >
              {slide.sub}
            </p>

            {/* CTAs */}
            <div
              className="flex flex-col sm:flex-row items-center justify-center gap-4"
              style={{
                opacity: textVisible ? 1 : 0,
                transform: textVisible ? 'none' : 'translateY(10px)',
                transition: 'opacity 0.7s ease 0.5s, transform 0.7s ease 0.5s',
              }}
            >
              <Link
                to="/contacto"
                className="group flex items-center gap-3 px-10 py-4 font-black text-sm tracking-widest uppercase rounded-full hover:opacity-90 transition-all duration-300 cursor-pointer whitespace-nowrap hover:scale-105"
                style={{
                  background: 'linear-gradient(135deg, #ff6f00 0%, #e65100 100%)',
                  color: '#fff',
                  fontFamily: "'Montserrat', sans-serif",
                  boxShadow: '0 4px 20px rgba(230,81,0,0.45)',
                }}
              >
                <i className="ri-price-tag-3-fill group-hover:scale-125 transition-transform duration-300"></i>
                Cotiza tu Proyecto
              </Link>
              <Link
                to="/sobre-nosotros"
                className="flex items-center gap-3 px-10 py-4 border-2 border-white/60 text-white font-bold text-sm tracking-widest uppercase rounded-full hover:bg-white/12 hover:border-white transition-all duration-300 cursor-pointer whitespace-nowrap"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                Sé un Aliado FRAIS
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          {/* Slide thumbnails */}
          <div className="w-full pb-5">
            <div className="flex items-end justify-center gap-2 mb-3 flex-wrap">
              {slides.map((s, idx) => (
                <button
                  key={idx}
                  onClick={() => resetInterval(idx)}
                  className="relative overflow-hidden rounded-lg cursor-pointer flex-shrink-0"
                  style={{
                    width: current === idx ? '80px' : '48px',
                    height: current === idx ? '56px' : '38px',
                    opacity: current === idx ? 1 : 0.45,
                    transition: 'all 0.4s ease',
                    outline: current === idx ? `2px solid ${s.accent}` : 'none',
                    outlineOffset: '2px',
                  }}
                >
                  <img src={s.src} alt="" className="w-full h-full object-cover" />
                  {current === idx && (
                    <div
                      className="absolute bottom-0 left-0 h-0.5 rounded-full"
                      style={{ backgroundColor: s.accent, animation: 'slideProgress 5.5s linear forwards' }}
                    ></div>
                  )}
                </button>
              ))}
            </div>
            <div className="flex items-center justify-center gap-3">
              <span
                className="text-white/40 text-[10px] tracking-[0.3em] uppercase"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                {String(current + 1).padStart(2, '0')} / {String(slides.length).padStart(2, '0')}
              </span>
              <div className="w-16 h-px bg-white/20 relative overflow-hidden rounded-full">
                <div
                  className="absolute left-0 top-0 h-full bg-white/60 rounded-full"
                  style={{ width: `${((current + 1) / slides.length) * 100}%`, transition: 'width 0.6s ease' }}
                ></div>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll hint */}
        <div className="absolute bottom-28 right-8 z-10 flex-col items-center gap-2 hidden md:flex">
          <div className="w-5 h-8 border border-white/25 rounded-full flex items-start justify-center p-1">
            <div className="w-1 h-2 bg-white/50 rounded-full" style={{ animation: 'scrollDot 2s ease-in-out infinite' }}></div>
          </div>
          <span
            className="text-white/30 text-[8px] tracking-[0.4em] uppercase"
            style={{ fontFamily: "'Montserrat', sans-serif", writingMode: 'vertical-lr' }}
          >
            Scroll
          </span>
        </div>
      </div>

      {/* Stats bar — warm amber tones */}
      <div className="w-full" style={{ background: 'linear-gradient(90deg, #e65100 0%, #bf360c 100%)' }}>
        <div className="flex flex-col sm:flex-row items-stretch divide-y sm:divide-y-0 sm:divide-x divide-white/15">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="flex-1 flex flex-col items-center justify-center py-7 px-6 hover:bg-white/8 transition-colors duration-300"
            >
              <span
                className="text-[#ffcc80] text-2xl md:text-3xl font-bold mb-1"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                {stat.value}
              </span>
              <span
                className="text-white/70 text-xs tracking-wide text-center"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes heroZoom {
          from { transform: scale(1.04); }
          to   { transform: scale(1); }
        }
        @keyframes scrollDot {
          0%, 100% { transform: translateY(0); opacity: 0.5; }
          50% { transform: translateY(12px); opacity: 0.15; }
        }
        @keyframes slideProgress {
          from { width: 0%; }
          to   { width: 100%; }
        }
      `}</style>
    </section>
  );
}
